import ApiResponse from "@core/types/apiResponse";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import {
    FinanceCategoryResponse,
    FinanceCategoryCalcTypeOption,
} from "@features/admin/finance/category/types/financeCategory";
import {
    CreateFinanceCategoryRequest,
    UpdateFinanceCategoryRequest,
} from "@features/admin/finance/category/types/financeCategoryRequests";
import {
    fetchFinanceCategoryCalcTypes,
    fetchFinanceCategories,
    createFinanceCategory,
    updateFinanceCategory,
    disableFinanceCategory,
    enableFinanceCategory,
} from "@features/admin/finance/category/api/financeCategoryApi";

export const fetchFinanceCategoryCalcTypesAsync = async (
    nationId: number
): Promise<ApiResponse<FinanceCategoryCalcTypeOption[]>> => {
    return fetchFinanceCategoryCalcTypes(nationId);
};

export const fetchFinanceCategoriesAsync = async (
    nationId: number,
    params: any
): Promise<ApiResponse<FinanceCategoryResponse>> => {
    const { nationId: _removed, ...filteredParams } = params || {};
    return fetchFinanceCategories(nationId, filteredParams);
};

export const createFinanceCategoryAsync = async (
    nationId: number,
    data: CreateFinanceCategoryRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return createFinanceCategory(nationId, data);
};

export const updateFinanceCategoryAsync = async (
    nationId: number,
    categoryGroupId: number,
    data: UpdateFinanceCategoryRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return updateFinanceCategory(nationId, categoryGroupId, data);
};

export const disableFinanceCategoryAsync = async (
    nationId: number,
    categoryGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return disableFinanceCategory(nationId, categoryGroupId);
};

export const enableFinanceCategoryAsync = async (
    nationId: number,
    categoryGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return enableFinanceCategory(nationId, categoryGroupId);
};
